module.exports = __webpack_public_path__ + "img/bell-hover.664add69.svg";